import { required, numeric } from "vuelidate/lib/validators";
import { requiredIf } from "vuelidate/lib/validators";
export default {
    name: {
        required,
    },
    description: {},
    country_id: {
        required,
    },
    language_id: {
        required,
    },
    active: {
        required,
    },
    campaing_type: {},
    capping_end_date: {
        required,
    },
    end_date: {
        required: requiredIf(function (nestedModel) {
            return (
                nestedModel.capping_end_date === true
            );
        }),
    },
    advance_validation: {},
    cost_price: {},
    automatic_phone_validation_status: {},
    automatic_phone_validation_mode: {
        required: requiredIf(function (nestedModel) {
            return (
                nestedModel.automatic_phone_validation_status === true
            );
        }),
    },
    autocomplete_geolocation_status: {},
    delivery_campaign_id: {},
    client_group_id: {}
}